import { APP_PDC_URL } from "../../config";

import { callWithRetry } from "../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../services/http-header";

export const dashboardConstants = {
  GET_LAST_EINVOICES_START: "GET_LAST_EINVOICES_START",
  GET_LAST_EINVOICES_ERROR: "GET_LAST_EINVOICES_ERROR",
  GET_LAST_EINVOICES_SUCCESS: "GET_LAST_EINVOICES_SUCCESS"
};

export function getLastEInvoices() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const clientIdSelected = getState().main.clientIdSelected;
    const accountantIdSelected = getState().main.accountantIdSelected;

    let urlActive = `${APP_PDC_URL}/v2/documents?itemId=${clientIdSelected}&accountantId=${accountantIdSelected}&category=Fatture%20emesse&prefix=`;
    let urlPassive = `${APP_PDC_URL}/v2/documents?itemId=${clientIdSelected}&accountantId=${accountantIdSelected}&category=Fatture%20ricevute&prefix=`;
    let requestActive = {
      method: "GET",
      url: `${urlActive}`,
      headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
    };
    let requestPassive = {
      method: "GET",
      url: `${urlPassive}`,
      headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
    };
    return new Promise(function(resolve, reject) {
      dispatch({
        type: dashboardConstants.GET_LAST_EINVOICES_START
      });
      return callWithRetry(
        auth, requestActive, dispatch
      )
        .then((result) => {
          const activeInvoices = result.data.results;
          if (result.status === 200) {
            callWithRetry(
              auth, requestPassive, dispatch
            ).then((resultPassive) => {
              const passiveInvoices = resultPassive.data.results;
              if (resultPassive.status === 200) {
                dispatch({
                  type: dashboardConstants.GET_LAST_EINVOICES_SUCCESS,
                  payload: {
                    active: activeInvoices,
                    passive: passiveInvoices
                  }
                });
                resolve({
                  active: activeInvoices,
                  passive: passiveInvoices
                });
              } else {
                dispatch({
                  type: dashboardConstants.GET_LAST_EINVOICES_ERROR,
                  error: resultPassive
                });
                reject();
              }
            });
          } else {
            dispatch({
              type: dashboardConstants.GET_LAST_EINVOICES_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: dashboardConstants.GET_LAST_EINVOICES_ERROR,
            error: response
          });
          reject(JSON.parse(JSON.stringify(response)));
        });
    });
  };
}
